export const mobileRegExp = /iPad|iPhone|iPod|Android/i

export const mobileIosPlatforms = [
	'iPad Simulator',
	'iPhone Simulator',
	'iPod Simulator',
	'iPad',
	'iPhone',
	'iPod'
]

export const userAgentMac = 'Mac'
